<script>
  export let title = '';
  export let subtitle = '';
</script>

<div class="settings">
  <div>
    <div class="title">{title}</div>
    <div class="subtitle">{subtitle}</div>
  </div>
  <slot name="content" />
</div>

<style>.settings{align-items:center;border-bottom:1px solid #d0d0d2;color:var(--t-c);display:flex;flex-direction:row;justify-content:space-between;padding:1em 0}.title{font-size:16px;font-weight:400}.subtitle{color:var(--t-c-l);font-size:14px;font-weight:400}@media (max-width:450px){.settings{display:block;padding:.5em 0}}</style>
